export default "__VITE_ASSET__f9dce177__"